import { Loading } from 'entoro-shared';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import React from 'react';
import CommentCard from './CommentCard';
import { compose, graphql } from 'react-apollo';
import { offerCommentsQuery } from '../../../apollo';
const CommentSection = ({ comments, loading, offer, investorUser }) => {
  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {comments && comments.length ? (
        <h3> Comments ({comments && comments.length})</h3>
      ) : (
        ''
      )}

      {comments &&
        comments.map((comment, key) => (
          <CommentCard
            comment={comment}
            offer={offer}
            investorUser={investorUser}
            index={key}
          />
        ))}
    </div>
  );
};

const WithDataHOC = (ComponentToWrap) => (props) => {
  const { offer } = props;
  const WithData = compose(
    graphql(offerCommentsQuery, {
      options: ({ match }) => ({
        variables: {
          offerId: offer._id,
        },
      }),
    })
  )(ComponentToWrap);

  return <WithData {...props} />;
};

export default connect()(withApollo(WithDataHOC(CommentSection)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/CommentSection.js